var data = { header:{ text:"#### Warning",
    closeButton:true },
  body:{ text:"Fragile X - Related Disorders, Diagnostic must be ordered in conjunction with another Developmental Disorders test (CMA or Karyotype). Please add one of these tests to the cart before adding Fragile X." },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=fragile_x_only_error.esm.js.map
